import { Persona } from '@localStorage/domain/models/Persona'
import { User } from '@localStorage/domain/models/User'
import { LocalStorageRepository } from '@localStorage/domain/repositories/LocalStorageRepository'
import { localDatasource } from '@localStorage/infra/datasource/LocalDatasource'

const userKey = 'user'
const personaKey = 'persona'
const filterKey = 'ms-filter'
const occurrencesFilterKey = 'occurences-filter'

export const localStorageRepositoryAdapter = (
  datasource: localDatasource
): LocalStorageRepository => {
  let currentUser: User | null = null
  let currentPersona: Persona | null = null

  return {
    setUser(user) {
      currentUser = user
      return datasource.store(userKey, user)
    },

    getUser() {
      if (currentUser) return currentUser
      return datasource.get(userKey)
    },

    deleteUser() {
      currentUser = null
      return datasource.delete(userKey)
    },

    setPersona(persona) {
      currentPersona = persona
      return datasource.store(personaKey, persona)
    },

    getPersona() {
      if (currentPersona) return currentPersona
      return datasource.get(personaKey)
    },

    deletePersona() {
      currentPersona = null
      return datasource.delete(personaKey)
    },

    setSessionManagementFilter(filter) {
      return datasource.store(filterKey, filter)
    },

    getSessionManagementFilter() {
      return datasource.get(filterKey)
    },

    deleteSessionManagementFilter() {
      return datasource.delete(filterKey)
    },
    setOccurrencesFilter(filter) {
      return datasource.store(occurrencesFilterKey, filter)
    },

    getOccurrencesFilter() {
      return datasource.get(occurrencesFilterKey)
    },

    deleteOccurrencesFilter() {
      return datasource.delete(occurrencesFilterKey)
    },

    clear() {
      datasource.clear()
    }
  }
}
